<script lang="ts">
	import EllipseOverlapCircle from '$lib/popups/createSCWallet/EllipseOverlapCircle.svelte';
	import { scale } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import { executeCreateWallet } from '$lib/util/common';
	import { creatingSmartContractWallet } from '../popupsStore';
	import ProcessingButton from '$lib/util/ProcessingButton.svelte';
	import { scWalletAccountResolver } from '$lib/wallet/store';
</script>

<GradientBorder
	gradient="bg-fx-gradient-6 "
	paddingClass="p-px"
	borderRadius="rounded-2xl squircle"
	innerClassList="bg-fx-gradient-8 "
>
	<div class="flex flex-col justify-center items-center p-8">
		<div class="bg-fx-gradient-6 flex flex-col squircle rounded-xl p-3 gap-3 max-w-sm items-center">
			<div in:scale={{ duration: 250, delay: 0, opacity: 0.5, start: 0.9, easing: quintOut }}>
				<img
					loading="lazy"
					src={'scwallet/smart-contract-wallet-1.webp'}
					class="animate-[pulse_3s_ease-in-out_infinite]"
					alt=""
				/>
			</div>
			<div class="text-white text-sm text-center font-demibold text-fx-gradient-5">
				Build your Smart Contract Wallet to maximize <br />
				the trade experience with Polynomial.
			</div>

			<div class="flex items-center">
				<EllipseOverlapCircle />
				<div class="text-fx-grey-400 text-xs">Trade/Hedge/Long/Short like a whale</div>
			</div>

			<div class="flex items-center">
				<EllipseOverlapCircle />
				<div class="text-fx-grey-400 text-xs">With Low fees and Deep Liquidity</div>
			</div>

			<div class="flex items-center">
				<EllipseOverlapCircle />
				<div class="text-fx-grey-400 text-xs">Upto 50x leverage</div>
			</div>
		</div>

		<div class="w-full my-6 border-fx-grey-800 border" />

		<div class="w-full text-fx-grey-400 text-xs mb-6 text-center">
			To start using Polynomial, you need to create a Smart Contract<br /> Wallet account and then you
			can deposit in it to place trade.
		</div>
		<div class="w-full">
			{#if $creatingSmartContractWallet}
				<ProcessingButton title="Creating Polynomial Wallet" />
			{:else}
				<div
					on:click={async () => executeCreateWallet($scWalletAccountResolver)}
					on:keydown={async () => executeCreateWallet($scWalletAccountResolver)}
					class="flex justify-center items-center gap-3 text-fx-grey-900 font-semibold text-center rounded-xl squircle-xl bg-fx-gradient-9 py-4 cursor-pointer w-full"
				>
					Create Polynomial Wallet
				</div>
			{/if}
		</div>
	</div>
</GradientBorder>
